module.exports = __webpack_public_path__ + "static/media/upload_photo_defulticon.20e49e1f.png";